import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import SimpleAvatar from '../../../../../common/SimpleAvatar';
import { chatMembersModalActions } from '../../../../../../redux/healthboard/patientPortal/chat-members-modal';
import { loggedUserIdSelector } from '../../../../../../redux/context/selectors';
import { formatDate } from '../../../../utils';
import { getSafeAction, getSafeRole } from '../../../utils';
import styles from './index.styl';

const ActivityLog = ({ entity, formatMessage }) => {
  const {
    requesterUser = {},
    createdAt,
    category,
    chatroomName,
    chatShareEventParticipants,
    filename,
    messageType,
    ipAddress,
    email,
    title,
  } = entity || {};
  const dispatch = useDispatch();
  const loggedUserId = useSelector(loggedUserIdSelector);

  const user = formatMessage({
    id: 'patient.portal.healthRecord.activityLog.user',
  });

  const verifySafeUserRole = () => {
    return requesterUser.requesterUserId === loggedUserId
      ? formatMessage({
          id: 'patient.portal.healthRecord.activityLog.you',
        })
      : getSafeRole(requesterUser.role, formatMessage);
  };

  const safeUserName =
    ipAddress && !requesterUser.requesterUserId
      ? `${user} ${ipAddress}`
      : `${requesterUser.firstName || ''} ${requesterUser.lastName || ''}`;
  const safeRole =
    ipAddress && !requesterUser.requesterUserId ? '' : verifySafeUserRole();
  const safeAction = getSafeAction(
    messageType,
    category,
    title,
    filename,
    chatroomName,
    email,
    chatShareEventParticipants,
    formatMessage,
  );
  const handleOpenSeeMembersModal = () => {
    dispatch(
      chatMembersModalActions.open({
        date: createdAt ? formatDate(createdAt, 'MMM D, Y h:mm A') : '',
        chatRoomName: chatroomName,
        memberList: chatShareEventParticipants,
      }),
    );
  };

  return (
    <div className={styles.root}>
      <div className={styles.leftSideWrapper}>
        <SimpleAvatar
          className={styles.avatar}
          text={get(requesterUser, 'firstName') || user}
          src={get(requesterUser.avatar, 'thumbMin')}
          size={32}
        />
        <div className={styles.description}>
          <span>
            {`${safeUserName} ${safeRole ? `(${safeRole})` : ''} ${safeAction}`}
            <span>
              {chatShareEventParticipants.length > 0 && (
                <Fragment>
                  <span> - </span>
                  <span
                    className={styles.actionButton}
                    onClick={handleOpenSeeMembersModal}
                  >
                    {formatMessage({
                      id: 'patient.portal.healthRecord.activityLog.seeMembers',
                    })}
                  </span>
                </Fragment>
              )}
            </span>
          </span>
        </div>
      </div>
      <div className={styles.date}>
        {createdAt ? formatDate(createdAt, 'MMM D, Y h:mm A') : ''}
      </div>
    </div>
  );
};

ActivityLog.propTypes = {
  entity: PropTypes.object,
  formatMessage: PropTypes.func,
};

export default ActivityLog;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/ActivityLog/index.jsx